import { RadioIconTheme, styles, variants } from '../RadioIconStyles.css';
import { baseTheme } from './RadioIconBaseTheme.css';
import { multiVariantStyles } from './RadioIconVariants.css';

/*******************
 * Component Theme
 *******************/

const RadioIconStableTheme: RadioIconTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { RadioIconStableTheme };
